












































import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import BaseComponent from '@/components/base-component.vue';
import PrescriptionGeneralResume from '@/components/prescription/resume/general-resume.vue';
import PrescriptionPatientResume from '@/components/prescription/resume/patient-resume.vue';
import PrescriptionResumeProducts from '@/components/prescription/resume/products-resume.vue';
import PrescriptionValidationMessages from '@/components/prescription/validation-messages.vue';
import WhatsappButton from '@/components/UI/whatsapp-button.vue';
import PrescriptionModel from '@/models/prescription-model';

@Component({
  components: {
    PrescriptionPatientResume,
    PrescriptionGeneralResume,
    PrescriptionValidationMessages,
    PrescriptionResumeProducts,
    WhatsappButton
  },
})
export default class PrescriptionFormBase extends BaseComponent {
  @Prop()
  public item: PrescriptionModel;
  @Prop()
  public prescriptionState: any;
  @Prop()
  public validationMessages: any[];
  @Prop()
  public validationMessagesLoading: boolean;
  @Prop()
  public validationMessagesError: boolean;
  @Prop()
  public validationMessagesFirstTime: boolean;
  @Prop()
  public idsProdWaiting: Number[];
  @Prop()
  public isTranscription: boolean;

  public openResumeSection: boolean = false;
  public isAlertModalOpen: boolean = false;

  public toggleResumeSection(): void {
    this.openResumeSection = !this.openResumeSection;
  }

  public onClickShowErrorProducts(val): void {
    this.$emit('clickShowErrorProducts', val);
  }

  public onClickFocusErrorProduct(val): void {
    this.$emit('clickFocusErrorProduct', val);
    this.isAlertModalOpen = false;
  }
}
